// extracted by mini-css-extract-plugin
module.exports = {"title":"Yale_title__2e0_u","subtitle":"Yale_subtitle__DXkJn","image":"Yale_image__cpL2m","caption":"Yale_caption__3aSW4","description":"Yale_description__1EnkS"};